
import { defineComponent, ref, computed } from 'vue'
import axios from "axios";
import { message } from "ant-design-vue";
import store from '@/store'

declare let hexMd5: any
declare let KEY: any

export default defineComponent({
  name: 'the-header',
  setup() {

    // const user = ref()
    // user.value = {}

    const user = computed(() => store.state.user)

    // 用来登录
    const loginUser = ref({
      loginName: 'test',
      password: '123456'
    })
    const loginModalVisible = ref(false)
    const loginModalLoading = ref(false)
    // 显示登录模态框
    const showLoginModal = () => {
      loginModalVisible.value = true
    }

    // 登录
    const login = () => {
      console.log('开始登录')
      loginModalLoading.value = true
      // 前端校验
      // if (loginUser.value.password.length < 6 || loginUser.value.password.length > 20) {
      //   message.error('【密码】6~20位')
      // }
      loginUser.value.password = hexMd5(loginUser.value.password + KEY)
      axios.post("/user/login", loginUser.value).then((res) => {
        loginModalLoading.value = false
        const data = res.data
        if (data.success) {
          loginModalVisible.value = false
          message.success("登录成功!")
          // user.value = data.content
          // 触发vuex的方法
          store.commit("setUser", data.content)
        } else {
          message.error(data.message)
        }
      })
    }

    // 退出登录
    const logout = () => {
      console.log('退出登录开始')
      axios.get("/user/logout/" + user.value.token).then((res) => {
        const data = res.data
        if (data.success) {
          message.success("退出成功")

          store.commit("setUser", {})
        } else {
          message.error(data.message)
        }
      })
    }

    return {
      loginModalVisible,
      loginModalLoading,
      showLoginModal,
      loginUser,
      login,
      user,
      logout
    }
  }
})
